module.exports = __webpack_public_path__ + "static/media/lock-open.ed61ab3f.svg";